import { Component, EventEmitter, Inject, Input, LOCALE_ID, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Message, ConfirmationService, ConfirmEventType, MenuItem, MessageService } from 'primeng/api';
import { DynamicFormComponent } from 'src/app/misc/component/dynamic-form/dynamic-form.component';
import { HeaderComponent } from 'src/app/admin/layout/header/header.component';
import { QuestionBase } from 'src/app/misc/component/dynamic-form/question-base';
import { DropdownQuestion } from 'src/app/misc/component/dynamic-form/question-dropdown';
import { TextEditorQuestion } from 'src/app/misc/component/dynamic-form/question-editor';
import { TextboxQuestion } from 'src/app/misc/component/dynamic-form/question-textbox';
import { DataService } from 'src/app/services/data.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { link, breadcrumb, stat } from '../../layout/header/header.component';
import { TimePickerQuestion } from 'src/app/misc/component/dynamic-form/question-timepicker';
import { RadioButtonQuestion } from 'src/app/misc/component/dynamic-form/question-radiobutton';
import { TextAreaQuestion } from 'src/app/misc/component/dynamic-form/question-textarea';
import { DatePipe, formatDate } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { cloneDeep, floor } from 'lodash';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { SurveyAssessment } from 'src/app/misc/enums/survey-assessment.enum';
import { functionLink } from 'src/app/misc/component/dynamic-form/question-functionLink';


@Component({
  selector: 'app-assessment',
  templateUrl: './assessment.component.html',
  styleUrl: './assessment.component.scss'
})
export class AssessmentComponent {
  skelition = true;

  @Input() assessmentTypeId: string = '';
  @Input() fromTraining: boolean = false;
  @Input() trainingTypeId: string = "";

  @Output() newAssess = new EventEmitter<any>();

  @Input() updateAssesData: any;

  @Output() updateAssesment = new EventEmitter<any>();

  @ViewChild(DynamicFormComponent) DynamicFormComponent:
    | DynamicFormComponent
    | any;
  @ViewChild(HeaderComponent) HeaderComponent: HeaderComponent | undefined;
  messages: Message[] = [];
  menuItems: MenuItem[] = [
    {
      label: '<span class="mx-3">تعديل</span>',
      escape: false,
      icon: 'pi pi-refresh',
      command: () => {
        this.assessmentActionCall({ id: this.operationAssessment._id, action: 'Update' })
      }
    },
    {
      label: '<span class="mx-3">حذف</span>',
      escape: false,
      icon: 'pi pi-fw pi-trash',
      command: () => {
        this.assessmentActionCall({ id: this.operationAssessment._id, action: 'Delete' })
      }
    }
  ];

  header = this.translate('Assessments');
  links: link[] = [
    {
      name: this.translate('Add Topic'),
      icon: 'pi pi-plus',
      link: '/assessment/topics',
      visible: this.hasPermission('GENERAL_TOPIC', 'a')
    },
    {
      name: this.translate('Add Standard Question Bank'),
      icon: 'pi pi-plus',
      link: '/assessment',
      queryParams: { 'QBankId': '65f71c25cf3086b3277d7f2d', 'tabIndex': 1 },
      visible: this.hasPermission('GENERAL_QB', 'a')
    },
    {
      name: this.translate("Tags Management"),
      icon: 'pi pi-plus-circle',
      link: '/assessment/tags-management',
      visible: this.hasPermission('SURVEY_TAGS', 'c') || this.hasPermission('SURVEY_TAGS', 'u') || this.hasPermission('SURVEY_TAGS', 'd')
    },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('Assessments'), link: '/assessment' },
  ];
  queryParams: any = {};
  stats: stat[] = [];
  translator: TranslatorPipe = new TranslatorPipe()
  page: number = 1;
  rows: number = 10;
  first = 1;

  totalDocuments: number = 0;
  assessments: any[] = [];
  types: any[] = [];
  operationAssessment: any;
  statusOptions: string[] = ['Pending', 'Active', 'Closed']
  questions: QuestionBase<string>[] = [];
  allowedTags: string[] = this.permissionService.extractTags('ASSESSMENT_TAGS', 'r')
  allTags: string[] = [];
  // Update data
  updateModal = false;
  updateData: any;
  updateQuestions: any;

  openCreateModal: boolean = this.fromTraining;
  checkboxValue: boolean = false;
  selectedAssessments: any[] = []
  operationType: any;
  templateSelectionList: any[] = [];

  //Question Bank
  questionBankService: any[] = [];
  questionBankTopics: any[] = [];
  currentQBank: any;
  currentQBankId: string = "";
  questionBanks: any[] = [];
  standardQBs: any[] = [];

  activeTabIndex: number = 0;

  sortField: string = '';
  sortDirection: string = 'desc';
  topics: any[] = [];

  standardQBID: string = '65f71c25cf3086b3277d7f2d';
  ministries: any[] = [];
  clonedAssessment: any = {};
  isCopy: string = 'false';
  questionBanksAll: any[] = [];

  originalAssessments: any[] = []; // Filtered list for display
  searchQuery: string = ''; // Search query

  constructor(
    private dataService: DataService,
    private confirmationService: ConfirmationService,
    public permissionService: PermissionHandlerService,
    @Inject(LOCALE_ID) private locale: string,
    private router: Router,
    private activatedRouter: ActivatedRoute,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.skelition = true;
    Promise.all([
      this.getAssessmentTags(),
      this.getAllQuestionBanks()
    ]).then(e => {
      console.log("asd", this.skelition);
      const savedTabIndex = localStorage.getItem('activeTabIndex');
      if (savedTabIndex !== null) {
        this.activeTabIndex = +savedTabIndex;
      }
      this.makequestion();
      console.log('ALL TAGS', this.allTags);
      console.log('ALL QuestionBanks', this.questionBanks);

      this.activatedRouter.queryParams.subscribe(params => {
        if (params['page'] && params['rows']) {
          this.page = Number(params['page']);
          this.rows = Number(params['rows']);
        }

        console.log("allparams", params)

        console.log("Rows", this.rows);
        console.log("New Page", this.page);

        if (params['QBankId']) {
          this.currentQBankId = params['QBankId'];
        }
        if (params['tabIndex']) {
          const savedTabIndex = +params['tabIndex'];
          if (!isNaN(savedTabIndex)) {
            this.activeTabIndex = savedTabIndex;
          }
        }
        this.queryParams = { 'QBankId': this.currentQBankId, 'tabIndex': this.activeTabIndex };
        this.skelition = true;
        this.getQuestionBanks()
          .then(() => Promise.all([this.getStandardQB(), this.fetchTopics()]))
          .then(() => {
            this.skelition = false;
          })
          .catch((error) => {
            console.error('Error loading data:', error);
            this.skelition = false;
          });
      });


    })

    this.getAssessments();



  }

  filterAssessments(): void {
    console.log('FADebug Original Assessments:', this.originalAssessments);
    console.log('FADebug Search Query:', this.searchQuery);
    const query = this.searchQuery.toLowerCase();
    this.assessments = this.originalAssessments.filter((assessment) => {
      console.log('FADebug Assessment:', assessment);
      return (
        assessment.name?.toLowerCase().includes(query) ||
        (assessment.questionBank?.name &&
          assessment.questionBank.name.toLowerCase().includes(query))
      );
    });
    console.log('FADebug Filtered Assessments:', this.assessments);
  }


  openAddQuestionsPage(assessment: any) {
    this.router.navigate(['/assessment/add-question/', assessment._id], {
      queryParams: {
        QBankId: this.currentQBankId ? this.currentQBankId : assessment.questionBankId,
        tabIndex: this.activeTabIndex,
      }
    })
  }

  openResultsPage(assessment: any) {
    this.router.navigate(['/assessment/results/', assessment._id], {
      queryParams: {
        QBankId: this.currentQBankId ? this.currentQBankId : assessment.questionBankId,
        tabIndex: this.activeTabIndex,
        Main: 1
      }
    })
  }

  async ngOnChanges(simpleChange: SimpleChanges) {
    if (simpleChange['fromTraining']) {
      this.openCreateModal = this.fromTraining;
    }
    if (!!this.updateAssesData && !!this.updateAssesData.assessmentId) {
      await this.fetchData();
      this.fromTraining = true;
      this.assessmentActionCall({ id: this.updateAssesData.assessmentId, action: 'Update' })
    }

  }

  async fetchData() {
    try {
      // ${this.from}
      let res = await this.dataService.getData(`assessment/id/${this.updateAssesData.assessmentId}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.operationAssessment = res.data;

    } catch (e) {

    }
  }

  private async fetchTopics(): Promise<void> {
    let res = await this.dataService.getData(`question-bank/get-topics/1/1000/Topic`);
    console.log(res.data);
    if (res.error) {
      return;
    }
    this.topics = res.data;
  }

  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
    this.page = event.page + 1
    this.currentQBankId = "";

    const params = { page: this.page, rows: this.rows };


    this.router.navigate([], {
      relativeTo: this.activatedRouter,
      queryParams: params,
      queryParamsHandling: 'merge',
    });
  }

  onTabChange(event: any) {
    this.activeTabIndex = event.index;
    this.router.navigate([], {
      relativeTo: this.activatedRouter,
      queryParams: { tabIndex: this.activeTabIndex },
      queryParamsHandling: 'merge'
    });
  }


  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  hasPermission(unit: string, flag: string) {
    return this.permissionService.hasPermission(unit, flag);
  }

  async getAssessmentTags() {
    console.log('ALLOWED TAGS', this.allowedTags);
    try {
      let res = await this.dataService.getData('survey-tags/ASSESSMENT');
      if (res.error) {
        return;
      }
      if (this.allowedTags.includes('MASTER_TAG')) {
        this.allTags = res.data.filter((e: any) => e.tag != 'MASTER_TAG' && e.tag != 'GENERAL_QB').map((data: any) => {
          return {
            _id: data._id,
            label: data.arabic,
            value: data.tag
          }
        });
      } else {
        this.allTags = res.data.filter((e: any) => this.allowedTags.includes(e.tag) && e.tag != 'GENERAL_QB').map((data: any) => {
          return {
            _id: data._id,
            label: data.arabic,
            value: data.tag
          }
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  async getQuestionBanks() {
    if (this.fromTraining) {
      this.allowedTags = ["TAG_10"]
    }
    try {
      let res = await this.dataService.getData(`question-bank/${this.page}/${this.rows}/${this.allowedTags.join(',')}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.questionBanks = res.data.data;
      // if (!this.currentQBankId) {
      //   this.currentQBank = this.questionBanks[0];
      // } 


      if (!!this.currentQBankId) {
        this.currentQBank = this.questionBanks.find(e => e._id == this.currentQBankId);
      }
      if (!this.currentQBank && this.fromTraining == false) {
        this.currentQBankId = "";
        this.router.navigate(['/assessment']);
      }

      const compare = (a: any, b: any) => {
        return b - a;
      }

      //Getting top 10 latest edited or created entries to show by default
      this.assessments = this.questionBanks.flatMap(e => e.assessments).sort((a, b) => compare(new Date(a.updatedAt), new Date(b.updatedAt))).slice(0, 10);

      if (!!this.currentQBank) {
        this.currentQBankId = this.currentQBank._id;
        this.questionBankTopics = this.currentQBank.topics.filter((item: { type: string; }) => item.type === 'Topic');
        this.questionBankService = this.currentQBank.topics.filter((item: { type: string; }) => item.type === 'Service');
        this.assessments = this.currentQBank.assessments;
      }
      this.questionBanks = this.questionBanks.filter(item => item._id !== this.standardQBID);
      this.totalDocuments = res.data.documentCount;

      this.originalAssessments = [...this.assessments];

    } catch (error) {
      console.log(error);
    }
  }

  async getAllQuestionBanks() {
    try {
      let res = await this.dataService.postData(`question-bank/getAll/${this.allowedTags.join(',')}`, null);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.questionBanksAll = res.data;

      this.activatedRouter.queryParams.subscribe(params => {
        if (params['QBankId']) {
          this.currentQBankId = params['QBankId'];
        }

        if (!!this.currentQBankId) {

          this.currentQBank = this.questionBanksAll.find(e => e._id == this.currentQBankId);

          const index = this.questionBanksAll.findIndex(e => e._id == this.currentQBankId);

          if (index !== -1) {
            this.page = Math.floor(index / this.rows) + 1;
            this.first = (this.page - 1) * this.rows; // Set first index properly
          }

          this.router.navigate([], {
            relativeTo: this.activatedRouter,
            queryParams: { page: this.page, rows: this.rows },
            queryParamsHandling: 'merge', // Merges with existing params
          });

        }


      });
    } catch (error) {
      console.log(error);
    }
  }

  async getStandardQB() {
    try {
      let res = await this.dataService.getData(`question-bank/${this.standardQBID}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.standardQBs = res.data;
      if (this.currentQBank?.standard && this.standardQBs.length > 0) {
        let StandardQBTopic = this.standardQBs[0].topics.filter((item: { type: string; }) => item.type === 'Topic');
        let StandardQBService = this.standardQBs[0].topics.filter((item: { type: string; }) => item.type === 'Service');
        this.questionBankTopics.push(...StandardQBTopic);
        this.questionBankService.push(...StandardQBService);
      }

      this.ministries = this.questionBankService
        .filter(item => item?.data && item.data.length > 0)
        .map(item => item.data[0]?.ministry)
        .filter((ministry, index, self) =>
          index === self.findIndex(t => (
            t.id === ministry.id
          ))
        );

      this.ministries.forEach((ministry) => {
        const ministryQuestionBanks = this.questionBankService.filter((item: { data: { ministry: { _id: any; }; }[]; }) => {
          return item.data && item.data[0] && item.data[0].ministry && item.data[0].ministry._id === ministry._id;
        });
        const questionBankCount = ministryQuestionBanks.length;
        let subTotalService = 0;
        ministryQuestionBanks.forEach((item: any) => {
          if (item.questions) {
            subTotalService += item.questions.length;
          }
        });
        ministry.total = questionBankCount;
        ministry.subTotal = subTotalService;
      });
    } catch (error) {
      console.log(error);
    }
  }

  changeCurrentQBank(event: any) {
    this.currentQBank = event;
    if (this.standardQBID == this.currentQBankId) {
      this.links.splice(1, 1);

      console.log("this.links", this.links);

      if (this.HeaderComponent) {
        console.log("asd");
        this.HeaderComponent.ngOnInit();
      }
    }
    this.skelition = true;
    this.getQuestionBanks()
      .then(() => {
        this.skelition = false;
      })
      .catch((error) => {
        console.error("Error loading question banks:", error);
        this.skelition = false;
      });

    this.router.navigate([], {
      relativeTo: this.activatedRouter,
      queryParams: { QBankId: this.currentQBank._id },
      queryParamsHandling: 'merge'
    });
  }

  getStatusArabic(status: string) {
    switch (status) {
      case this.statusOptions[0]:
        return "قيد الانتظار";
      case this.statusOptions[1]:
        return "نشط";
      case this.statusOptions[2]:
        return "غير نشط"
      default:
        return "";
    }
  }

  sortAssessments(field: string) {
    this.sortField = field;
    if (this.sortDirection === 'asc') {
      this.sortDirection = 'desc';
    } else {
      this.sortDirection = 'asc';
    }
    this.assessments.sort((a, b) => {
      if (this.sortDirection === 'asc') {
        if (a[field] < b[field]) return -1;
        if (a[field] > b[field]) return 1;
      } else {
        if (a[field] > b[field]) return -1;
        if (a[field] < b[field]) return 1;
      }
      return 0;
    });
  }


  getAssessments = async () => {
    this.assessments = [];
    this.selectedAssessments = [];
    try {
      let res = await this.dataService.getData(`assessment/${this.page}/${this.rows}/${this.allowedTags.join(',')}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.assessments = res.data.data;
      this.totalDocuments = res.data.documentCount

      this.originalAssessments = [...this.assessments];
    } catch (error) {
      console.log(error);
    }
  };

  createModal() {
    this.isCopy = 'false';
    this.makequestion();
    this.openCreateModal = true;
  }

  makequestion() {
    let today = new Date()
    this.questions = [
      new TextboxQuestion({
        key: 'name',
        label: this.translate('Name'),
        required: true,
        icon: 'pi pi-file',
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new DropdownQuestion({
        key: 'active',
        label: 'الحالة',
        options: [
          { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
          { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
        ],
        className: 'col-md-12 col-sm-12 col-12',
        value: true,
        visibility: "false",

      }),

      new TimePickerQuestion({
        key: 'startDate',
        label: 'تاريخ البدء',
        required: true,
        showTime: true,
        className: 'col-md-12 col-sm-12 col-12',
        visibility: this.fromTraining ? "false" : "true",
        value: this.fromTraining ? new Date() : null,
        touchUI: true
      }),

      new TimePickerQuestion({
        key: 'endDate',
        label: 'تاريخ الانتهاء',
        required: true,
        showTime: true,
        className: 'col-md-12 col-sm-12 col-12',
        visibility: this.fromTraining ? "false" : "true",
        touchUI: true,
        value: this.fromTraining ? new Date(today.getFullYear() + 1, today.getMonth(), today.getDate(), 0, 0, 0) : null
      }),

      new TextEditorQuestion({
        key: 'comments',
        label: 'الوصف',
        className: 'col-md-12 col-sm-12 col-12',
        visibility: "true",
      }),

      new DropdownQuestion({
        key: 'cloneQuestionBankId',
        label: 'المسارات',
        options: this.questionBanksAll.map(e => { return { label: e.name + ' (' + e.tag.arabic + ')', value: e._id } }),
        className: 'col-12',
        visibility: this.isCopy,
        value: this.assessmentTypeId
      }),

      new RadioButtonQuestion({
        key: 'accessType',
        label: 'النوع',
        options: [
          { label: this.translate('Through Knowledge Portal Users'), icon: 'pi pi-account', value: 'BY_ACCOUNT' },
          { label: this.translate('BY_LINK'), icon: 'pi pi-web', value: 'BY_URL' },
        ],
        visibility: (!this.fromTraining).toString(),
        className: 'col-md-12 col-sm-12 col-12',
        value: 'BY_ACCOUNT'
      }),

      new RadioButtonQuestion({
        key: 'copyType',
        label: this.translate('Copy Settings'),
        options: [
          { label: this.translate('ONLY_QUESTIONS'), icon: 'pi pi-web', value: 'ONLY_QUESTIONS' },
          { label: this.translate('SETTINGS_AND_QUESTIONS'), icon: 'pi pi-account', value: 'SETTINGS_AND_QUESTIONS' },
        ],
        visibility: this.isCopy,
        className: 'col-md-12 col-sm-12 col-12',
        value: 'ONLY_QUESTIONS'
      }),

      new TextboxQuestion({
        key: 'allowedAttempts',
        label: this.translate("allowedAttempts"),
        required: false,
        order: 1,
        icon: 'pi pi-file',
        visibility: this.fromTraining ? "true" : "false",
        className: 'col-12',
      }),
    ];
  }

  openAssessmentMenu(menu: any, event: any, assessment: any) {
    this.operationAssessment = assessment;
    console.log(this.operationAssessment)
    menu.toggle(event);
  }

  receiveAssessmentData = async ($event: any) => {
    try {
      let data = $event;
      data.testType = SurveyAssessment.ASSESSMENT;

      if (data.cloneQuestionBankId) {
        data.questionBankId = data.cloneQuestionBankId;
      }
      else if (this.assessmentTypeId) {
        data.questionBankId = this.assessmentTypeId;
      }
      else {
        data.questionBankId = this.currentQBank._id;
      }

      if (data.startDate.getTime() > data.endDate.getTime() || data.endDate.getTime() < data.startDate.getTime()) {
        console.log("Start data should be less than end date 3");
        this.messageService.add({
          severity: 'error',
          summary: this.translate('error'),
          detail: this.translate('Start data should be less than end date')
        });
        return;
      }
      if (this.clonedAssessment) {
        if (data.copyType == 'ONLY_QUESTIONS') {
          data.questions = this.clonedAssessment.questions;
        }
        else {
          data.questions = this.clonedAssessment.questions;
          data.externalQuestions = this.clonedAssessment.externalQuestions;
          data.topics = this.clonedAssessment.topics;
          data.settings = this.clonedAssessment.settings;
          data.percentageCriteria = this.clonedAssessment.percentageCriteria;
          data.certificateMinistry = this.clonedAssessment.certificateMinistry;
          data.showResult = this.clonedAssessment.showResult;
          data.showCert = this.clonedAssessment.showCert;
        }
      }
      data.startDate = formatDate(data.startDate, "dd-MM-YYYY HH:mm", this.locale);
      data.endDate = formatDate(data.endDate, "dd-MM-YYYY HH:mm", this.locale);

      if (this.fromTraining) {
        data.trainingTypeId = this.trainingTypeId;
      }

      let res = await this.dataService.postData('assessment', data);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      if (this.fromTraining) this.newAssess.emit(res);
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.DynamicFormComponent.resetForm();
      this.openCreateModal = false;
      this.isCopy = 'false'
      this.clonedAssessment = {};
      this.ngOnInit()
    } catch (error) {
      console.log(error);
    }
  };


  createGroup = async (ids: any) => {
    try {
      let data: any = {
        assessmentIds: ids
      }
      let res = await this.dataService.postData('assessment-group', data);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.selectedAssessments = [];
      this.ngOnInit()
    } catch (error) {
      console.log(error);
    }
  };

  updateAssessmentData = async (event: any) => {
    console.log('EVENT IS', event);
    try {
      let data: any = event;
      if (typeof data.startDate != 'string' && typeof data.endDate != 'string') {
        if (data.startDate.getTime() > data.endDate.getTime() || data.endDate.getTime() < data.startDate.getTime()) {
          this.messageService.add({
            severity: 'error',
            summary: this.translate('error'),
            detail: this.translate('Start data should be less than end date')
          });
          return;
        }
      } else {
        if (data.startDate > data.endDate || data.endDate < data.startDate) {
          this.messageService.add({
            severity: 'error',
            summary: this.translate('error'),
            detail: this.translate('Start data should be less than end date')
          });
          return;
        }
      }
      if (typeof data.startDate != 'string') {
        data.startDate = formatDate(data.startDate, "dd-MM-YYYY HH:mm", this.locale);
      }
      if (typeof data.endDate != 'string') {
        data.endDate = formatDate(data.endDate, "dd-MM-YYYY HH:mm", this.locale);
      }
      if (this.updateData) {
        data._id = this.updateData._id;
      }

      if (!!this.currentQBank) {
        data.questionBankId = this.currentQBank._id;
      } else {
        let qb = this.questionBanks.find(e => (e.assessments as Array<any>).some(f => f._id == data._id));
        data.questionBankId = qb._id;
      }

      if (typeof data.status != 'string') {
        data.status = data.status.label;
      }
      let res = await this.dataService.postData(
        'assessment',
        data,
        'PUT',
        false
      );
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      if (this.fromTraining) this.updateAssesment.emit(res);
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.updateModal = false;
      this.updateData = undefined;
      // updating in table
      this.ngOnInit();
    } catch (error) {
      console.log(error);
    }
  };

  markAll() {
    this.assessments.forEach((s: any) => {
      s.selected = this.checkboxValue;
    });
    if (this.checkboxValue) {
      this.selectedAssessments = this.assessments;
    } else {
      this.selectedAssessments = [];
    }
  }

  selectAssessment(assessment: any, value: boolean) {
    assessment.selected = value;
    if (assessment.selected) {
      this.selectedAssessments.push(cloneDeep(assessment));
    } else {
      this.selectedAssessments = this.selectedAssessments.filter(e => e._id != assessment._id)
    }
  }

  async bulkDelete() {

    try {
      let ids = this.selectedAssessments.map((s: any) => s._id);
      let res = await this.dataService.postData(`assessment/bulkdelete`, { 'ids': ids }, 'POST', false);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.selectedAssessments = []
      this.ngOnInit();
    } catch (error) {
      console.log(error);
    }
  }

  getTransformedDate(dateTime: string): string {
    const [datePart, timePart] = dateTime.split(' ');
    const [day, month, year] = datePart.split('-').map(Number);
    const dateObj = new Date(year, month - 1, day);
    let formattedDate = new DatePipe(this.locale, 'Asia/Riyadh').transform(dateObj);
    if (timePart) {
      const [hours, minutes] = timePart.split(':').map(Number);
      const timeObj = new Date(0, 0, 0, hours, minutes);
      const formattedTime = new DatePipe(this.locale).transform(timeObj, 'HH:mm');
      formattedDate += ' ' + formattedTime;
    }
    return formattedDate || '';
  }

  assessmentActionCall($event: any) {
    switch ($event.action) {
      case 'Results':
        let ids = this.selectedAssessments.map((s: any) => s._id);
        this.router.navigate(['/assessment/all-results'], { queryParams: { ids: ids } });
        console.log('PERMISSION C route to results')
        break;
      case 'Group':
        this.createGroup(this.selectedAssessments.map((s: any) => s._id));
        break;
      case 'Delete':
        this.confirm({
          message: this.translate('Are you sure you want to do this?'),
          header: this.translate('Confirmation message'),
          icon: 'pi pi-exclamation-triangle',
          action: () => {
            if ($event.bulk) {
              this.bulkDelete();
            } else {
              this.deletetAssessment($event.id);
            }
          },
        });
        break;
      case 'Update':
        this.updateData = this.operationAssessment;
        this.updateQuestions = [
          new TextboxQuestion({
            key: 'name',
            label: this.translate('Name'),
            required: true,
            order: 1,
            icon: 'pi pi-file',
            value: this.updateData.name,
            className: 'col-12',
          }),

          new TimePickerQuestion({
            key: 'startDate',
            label: 'تاريخ البدء',
            required: true,
            showTime: true,
            className: 'col-6',
            visibility: this.fromTraining ? "false" : "true",
            value: this.updateData.startDate,
            touchUI: true
          }),

          new TimePickerQuestion({
            key: 'endDate',
            label: 'تاريخ الانتهاء',
            required: true,
            showTime: true,
            className: 'col-6',
            visibility: this.fromTraining ? "false" : "true",
            value: this.updateData.endDate,
            touchUI: true
          }),

          new DropdownQuestion({
            key: 'status',
            label: 'الحالة',
            required: true,
            options: this.statusOptions.map(e => { return { label: this.getStatusArabic(e), value: e } }),
            className: 'col-12',
            visibility: "true",
            value: this.updateData.status
          }),

          new TextEditorQuestion({
            key: 'comments',
            label: 'الوصف',
            className: 'col-12',
            visibility: "true",
            value: this.updateData.comments
          }),

          new RadioButtonQuestion({
            key: 'accessType',
            label: 'النوع',
            options: [
              { label: this.translate('Through Knowledge Portal Users'), icon: 'pi pi-account', value: 'BY_ACCOUNT' },
              { label: this.translate('BY_LINK'), icon: 'pi pi-web', value: 'BY_URL' },
            ],
            visibility: "true",
            className: 'col-12',
            value: this.updateData.accessType
          }),

          new DropdownQuestion({
            key: 'active',
            label: 'الحالة',
            options: [
              { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
              { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
            ],
            className: 'col-md-12 col-sm-12 col-12',
            value: true,
            visibility: "false",

          }),

          new TextboxQuestion({
            key: 'allowedAttempts',
            label: this.translate("allowedAttempts"),
            required: false,
            order: 1,
            icon: 'pi pi-file',
            value: this.updateData.allowedAttempts,
            visibility: this.fromTraining ? "true" : "false",
            className: 'col-12',
          }),

          new functionLink({

            label: this.translate('Copy Link'),
            icon: 'pi pi-copy',
            function: () => {
              console.log('Copy Link Function Called');
              const copyText = `${window.location.origin}/sa/assessment/attempt/${this.updateData._id}`;
              navigator.clipboard.writeText(copyText).then(() => {
                this.messageService.add({
                  severity: 'success',
                  summary: this.translate('Link copied successfully'),
                });
              }).catch(err => {
                console.error('Failed to copy link: ', err);
                this.messageService.add({
                  severity: 'error',
                  summary: this.translate('Failed to copy link'),
                });
              });
            }

          })
        ];
        this.updateModal = true;
        break;
      default:
        console.log('Unknown color');
        break;
    }
  }

  getName(name: any) {
    if (!!name) {
      return name?.first + " " + name?.middle + " " + name?.last;
    }
    return "-"
  }

  deletetAssessment = async (id: string) => {
    try {
      let res = await this.dataService.deleteData(`assessment/${id}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.ngOnInit();
    } catch (error) {
      console.log(error);
    }
  };

  setCloneQestions(assessment: any, questionBankId: any) {
    this.assessmentTypeId = questionBankId;
    this.isCopy = 'true';
    this.makequestion();
    this.openCreateModal = true;
    this.clonedAssessment = assessment;
  }

  onDialogClose() {
    this.clonedAssessment = {};
    this.isCopy = 'false';
  }

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }
}
